var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat"},[_c('Launcher',{attrs:{"onMessageWasSent":_vm.onMessageWasSent,"isOpen":_vm.isChatOpen,"isMessageSent":_vm.isMessageSent,"close":_vm.closeChat,"open":_vm.openChat,"title":_vm.$t('feedback.header')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }